import { render, staticRenderFns } from "./bdfw.vue?vue&type=template&id=3f1c6cde&scoped=true&"
import script from "./bdfw.vue?vue&type=script&lang=js&"
export * from "./bdfw.vue?vue&type=script&lang=js&"
import style0 from "./bdfw.vue?vue&type=style&index=0&id=3f1c6cde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1c6cde",
  null
  
)

export default component.exports